import { id, matches, validRod, validIncorrectAnswer } from './model.mjs';

export const createIncorrectAnswer = () => ({id: id(), rods: [], specificFeedback: true, authorAdded: true, feedbackText: '', feedbackAudio: ''});

// The single-example draft format is accepted without rewriting saved content.
// New authoring uses stable IDs so selection survives adding/removing examples.
export function coachingIncorrectAnswers(segment) {
 if(Array.isArray(segment?.incorrectAnswers))return segment.incorrectAnswers;
 return segment?.incorrectAnswer ? [{...segment.incorrectAnswer,id:segment.incorrectAnswer.id||'legacy-incorrect-answer'}] : [];
}
export function selectedIncorrectAnswer(segment) {
 const answers=coachingIncorrectAnswers(segment);
 return answers.find(answer=>answer.id===segment?.editorIncorrectAnswerId)||answers[0]||null;
}

// Keep this separate from scoring: a recognized misconception is still an
// incorrect attempt. Other arrangements receive the ordinary retry feedback.
export function coachingFeedbackForArrangement(segment, rods) {
 if(segment?.type !== 'coaching' || !Array.isArray(rods) || !rods.every(validRod))return null;
 const options = {chart: !!segment.chart};
 const correct = segment.answer?.length ? segment.answer : segment.setup || [];
 // A mistaken author configuration must never override a correct response.
 if(matches(rods, correct, options))return null;
 const detail=coachingIncorrectAnswers(segment).find(answer=>answer.specificFeedback !== false
  && validIncorrectAnswer(answer) && answer.rods.length>0 && matches(rods,answer.rods,options));
 return detail ? {feedbackText:detail.feedbackText??'',feedbackAudio:detail.feedbackAudio??''} : null;
}
